import { render, staticRenderFns } from "./CobranzaDetailMini.vue?vue&type=template&id=0db85bec&scoped=true"
import script from "./CobranzaDetailMini.vue?vue&type=script&lang=js"
export * from "./CobranzaDetailMini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db85bec",
  null
  
)

export default component.exports